import * as _ from "lodash";
import * as types from './action-types';
import { IEmailTemplateState } from "./state";
import { IEmailTemplate } from '../../../models';

var initialState: IEmailTemplateState = {
    list: [],
    sendeeList: {
        emailAddressFields: [],
        contactEntityTypes: []
    },
    emailTags: [],
    emailPreview: {
        emailAddress: "",
        entityTypes: []
    }
}

export const Reducer = (state: IEmailTemplateState = initialState, action: any) => {
    let s = _.cloneDeep(state);

    switch (action.type) {
        case types.SET_EMAILTEMPLATES:
            s.list = action.list;
            return s;

        case types.SET_SENDEELISTS:
            s.sendeeList.emailAddressFields = action.emailAddressFields;
            s.sendeeList.contactEntityTypes = action.contactEntityTypes;
            return s;

        case types.SET_SAVEEMAILTEMPLATE:
            var emailTemplate: IEmailTemplate = action.emailTemplate;

            s.list = s.list.map(template => {
                if (template.id == emailTemplate.id)
                    return emailTemplate;
                else
                    return template;
            });

            return s;

        case types.SET_PREVIEWDATA:
            s.emailPreview = action.emailTemplatePreview
            return s;
    }

    return state;

}